module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-container"
  }, [_c('header', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "formbox"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("离我最近：")]), _vm._v(" "), _c('select', {
    attrs: {
      "id": "J_HospitalList"
    }
  }, _vm._l((_vm.hospitalItems), function(item) {
    return _c('option', {
      domProps: {
        "value": item.hospitalid
      }
    }, [_vm._v(_vm._s(item.hospitalname))])
  })), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_Name"
    }
  }, [_vm._v("真实姓名：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.patientname),
      expression: "user.patientname"
    }],
    attrs: {
      "type": "text",
      "id": "J_Name",
      "maxlength": "15",
      "placeholder": "用于就诊信息调用,务必正确填写"
    },
    domProps: {
      "value": (_vm.user.patientname)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.patientname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_Phone"
    }
  }, [_vm._v("手机号码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.tel),
      expression: "user.tel"
    }],
    attrs: {
      "type": "text",
      "id": "J_Phone",
      "maxlength": "11",
      "placeholder": "请填写手机号码"
    },
    domProps: {
      "value": (_vm.user.tel)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('phone')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.tel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('label', {
    attrs: {
      "for": "J_SmsCodeNumber"
    }
  }, [_vm._v("图片校验码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.imgcode),
      expression: "user.imgcode"
    }],
    attrs: {
      "type": "text",
      "id": "J_SmsCodeNumber",
      "maxlength": "4",
      "placeholder": "点击图片换一换"
    },
    domProps: {
      "value": (_vm.user.imgcode)
    },
    on: {
      "blur": function($event) {
        _vm.distributeType('smsCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.imgcode = $event.target.value
      }
    }
  }), _c('span', {
    staticClass: "codeimg"
  }, [_c('img', {
    attrs: {
      "src": "",
      "id": "J_SmsValidCode"
    },
    on: {
      "click": _vm.verifyCode
    }
  })])]), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('DownloadApp'), _vm._v(" "), _c('div', {
    staticClass: "error-tip",
    attrs: {
      "id": "J_ErrorTip"
    }
  }), _vm._v(" "), _c('el-amap', {
    attrs: {
      "plugin": _vm.plugin
    }
  }), _vm._v(" "), _c('MenuFooters', {
    attrs: {
      "isHide": _vm.isHide,
      "menuType": _vm.currentMenuType
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('img', {
    attrs: {
      "src": require("../assets/arrow_down.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('label', [_vm._v("就医时间：")]), _c('input', {
    attrs: {
      "type": "text",
      "id": "J_Date",
      "value": "",
      "placeholder": "请点击选择就医时间",
      "readonly": "",
      "onfocus": "javascript:this.blur();"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "btn"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "id": "J_OrderBtn",
      "value": "预约"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-772db23d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 197
// module chunks = 1